module.exports = __webpack_public_path__ + "static/media/tloczenie-geo.a12d88e9.svg";